// Account Registration module

define('modules/Product/ProductCodesService',[
    'jquery',
    'global/all',
    "plugins/jquery.proxyRequest"
], function ($, Roc) {
    'use strict';

    var apiUrl = window.RocConfig.api.baseRocApiUrl;

    function downloadProductCodes(productIds) {
        return $.proxyRequest({
            url: "/api/productcodes/download",
            type: 'POST',
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(productIds),
            dataType: 'json'
        });
    }

    var ProductCodesService = {
        downloadProductCodes: downloadProductCodes
    };

    Roc.Logger.debug('ProductCodesService.js Loaded:', ProductCodesService);

    return ProductCodesService;
});
